export default __webpack_public_path__ + "static/media/banner_sm.9770c3d0.svg";